import Button from 'components/Button'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'

import FilterData from './FilterData/index'
import FolderPath from './FolderPath/index'
import Header from './Header/index'
import SuccessIcon from 'components/icons/SubmitCloseIcon'
import TableData from './Table'
import InternshipsFilter from './Table/TableFilter/Partials/Internships'
import PlacementFilter from './Table/TableFilter/Partials/Placement'
import {
  FilterGap,
  MenuFlex,
  PlacementFlex,
  SelectAllFlex,
  StyledTab,
  SubmitFlex,
} from './style'
import { useSelector } from 'react-redux'
import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import ApprovedModelIcon from '../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import { singlePdf, zipFile } from '../../utils/downloadFile'
import SucessfullPopup from '../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import PopUpPageIcon from '../../components/icons/PopUpPageIcon'

const Placement = ({
  getPlacementData,
  instituteCampusId,
  getTableData,
  getUserBatchHistory,
  updateUserBatchHistory,
  getPlacementStudent,
  getYear,
  getPreviewData,
  getPlacementHistoryList,
  getStudentPlacedList,
  getJobRolePreview,
  getJobCategory,
  resumeBulkDownload,
}) => {
  const {userData,instituteDetails} = useSelector(state=>state.auth);
  const [folderData, setFolderData] = useState([])
  const [batchHistory, setBatchHistory] = useState([])
  const [folderSearch, setFolderSearch] = useState('')
  const [degreeValue, setDegreeValue] = useState({ name: '', id: '' })
  const [departValue, setDepartValue] = useState({ name: '', id: '' })
  const [domainValue, setDomainValue] = useState({ name: '', id: '' })
  const [debouncedFolderSearch, setDebouncedFolderSearch] = useState(
    () => folderSearch
  )
  const [jobCategoryList, setJobCategoryList] = useState([])
  const [yearValue, setYearValue] = useState({ year: '', endedOn: '' })
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(0)
  const [domainData, setDomainData] = useState([])
  const [degreeData, setDegreeData] = useState([])
  const [departData, setDepartData] = useState([])
  const [tableLoader, setTableLoader] = useState(false)
  const [placementStudent, setPlacementStudent] = useState('')
  const [searchBy, setSearchBy] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState(() => searchBy)
  const [sortBy, setSortBy] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [selectInternship, setSelectInternship] = useState(null)
  const [selectPlacement, setSelectPlacement] = useState(null)
  const [selectGigas, setSelectGigas] = useState(null)
  const [selectApprenticeship, setSelectApprenticeship] = useState(null)
  const [filterDatas, setFilterDatas] = useState([])
  const [yearData, setYearData] = useState([])
  const [searchData, setSearchData] = useState(false)
  const [searchFilter, setSearchFilter] = useState(false)
  const [tableDataLoaded, setTableDataLoaded] = useState(false)
  const [recentFolderClick, setRecentFolderClick] = useState(false)
  const [isNavigateEnabled, setIsNavigateEnabled] = useState(false)
  const [bulkDownload,setBulkDownload] = useState(false);
  const [studentListId,setStudentListId] = useState([]);
  const[actionDrawer,setActionDrawer] = useState(false);
  const [isAllSelect,setIsAllSelect] = useState(false);
  const[enabled,setEnabled] = useState(false)
  const [StudentId,setStudentId] = useState('')
  const [studentCount,setStudentCount] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)

  const navigate = useNavigate()
  const getLocation = useLocation()
  const currentSearchParams = new URLSearchParams(window.location.search)
  const GroupBy =
    currentSearchParams.get('groupBy')?.replace(/ /g, '%20') || 'type'
  const BreadOverview = currentSearchParams
    .get('overview')
    ?.replace(/ /g, '%20')
  const BreadEduType = currentSearchParams
    .get('educationType')
  const BreadDomain = currentSearchParams.get('domain')
  const DomainId = currentSearchParams.get('domainId')?.replace(/ /g, '%20')
  const DegreeId = currentSearchParams.get('degreeId')?.replace(/ /g, '%20')
  const BreadDegreeQuery = currentSearchParams
    .get('degree')
    ?.replace(/ /g, '%20')
    ?.split(',')
  const BreadDegree = BreadDegreeQuery?.[0]
  const BreadDegreeShortForm = BreadDegreeQuery?.[1]
  const BreadDepartId = currentSearchParams
    .get('departmentId')
    
  const BreadDepart = currentSearchParams
    .get('department')
    
  const BreadShowStudent = currentSearchParams.get('showStudent')
  const BreadYear = currentSearchParams.get('year')

  const breadCrumbData = [
    {
      title: 'Placement',
      name: 'Placement',
      ...(window.location.search === '' ? {} : { navigate: `/placement` }),

      active: window.location.search === '',
    },

    {
      title: `${BreadOverview}`,
      navigate: `/placement`,
      active: window.location.search === `?overview=${BreadOverview}`,
      name: `${BreadOverview}`,
    },
    {
      title: `${BreadEduType}`,
      navigate: `/placement?groupBy=domain&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&year=${BreadYear}`,
      active:
        window.location.search ===
          `?groupBy=domain&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&year=${BreadYear}` ||
        window.location.search ===
          `?groupBy=domain&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&year=${BreadYear}&showStudent=true`,
      name: `${BreadEduType} Batches`,
    },
    {
      title: `${BreadDomain}`,
      navigate: `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${BreadYear}`,
      active:
        window.location.search ===
          `?groupBy=degree&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${BreadYear}` ||
        window.location.search ===
          `?groupBy=degree&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${BreadYear}&showStudent=true`,
      name: `Domain - ${BreadDomain}`,
    },
    {
      title: `${BreadDegree}`,
      navigate: `/placement?groupBy=stream&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${BreadYear}`,
      active:
        window.location.search ===
          `?groupBy=stream&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${BreadYear}` ||
        window.location.search ===
          `?groupBy=stream&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${BreadYear}&showStudent=true`,
      name: `Degree - ${BreadDegree}`,
    },
    {
      title: `${BreadDepart}`,
      navigate: `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${encodeURIComponent(BreadDomain ?? '')}&year=${BreadYear}`,
      active:
        window.location.search ===
        `?groupBy=students&overview=${BreadOverview}&educationType=${encodeURIComponent(BreadEduType ?? '')}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(BreadDepart)}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${BreadDepartId}&year=${BreadYear}&showStudent=true`,
      name: `Department - ${BreadDepart}`,
    },
  ]

  useEffect(() => {
    if (isNavigateEnabled) {
      setPageSize(0)
      setSelectPlacement(null)
      setFilterDatas([])
      setDegreeValue([])
      setDepartValue([])
      setDomainValue([])
      setYearValue({ year: '', endedOn: '' })

      setIsNavigateEnabled(false)
    }
  }, [isNavigateEnabled])


  const handleShowStudent = () => {
    currentSearchParams.set('showStudent', 'true')

    navigate(`/placement${window.location.search}&showStudent=true`)
    handleUserBatchHistory('PUT', `${window.location.search}`)
  }

  const handleRecentRoute = routeTo => {
    if (routeTo) {
      navigate(`/placement${routeTo}`)
      setRecentFolderClick(true)
    }
  }

  const handleRouteCheck = (name, type, id, shortForm) => {
    if (type === 'domain') {
      navigate(
        `/placement?groupBy=${type}&overview=Overview&educationType=${name}&year=${yearValue.year}`
      )
    } else if (type === 'degree') {
      navigate(
        `/placement?groupBy=${type}&overview=Overview&educationType=${BreadEduType}&domain=${encodeURIComponent(name)}&domainId=${id}&year=${yearValue.year}`
      )
    } else if (type === 'stream') {
      navigate(
        `/placement?groupBy=${type}&overview=Overview&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${
          shortForm ? name?.trim() + ',' + shortForm + '' : name?.trim()
        }&domainId=${DomainId}&degreeId=${id}&year=${yearValue.year}`
      )
    } else if (type === 'students') {
      let finalRoute = `?groupBy=${type}&overview=Overview&educationType=${BreadEduType}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(name?.trim())}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${id}&year=${
        yearValue.year
      }&showStudent=true`
      navigate(
        `/placement?groupBy=${type}&overview=Overview&educationType=${BreadEduType}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(name?.trim())}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${id}&year=${
          yearValue.year
        }&showStudent=true`
      )
      handleUserBatchHistory('PUT', finalRoute?.toString(), name?.trim())
    } else if (type === '') {
      navigate(`/placement${window.location.search}&showStudent=true`)
    }
    setFolderData([])
  }

  const getYearData = async payLoad => {
    try {
      let data = payLoad ?? {
        educationLevel: BreadEduType,
        ...(domainValue && domainValue?.name !== ''
          ? {
              domainId: domainValue?.id,
            }
          : {}),
        ...(degreeValue && degreeValue?.name !== ''
          ? {
              degreeId: degreeValue?.id,
              degree: degreeData?.filter(
                item => item?.id === degreeValue?.id
              )[0]?.name,
            }
          : {}),
        ...(departValue && departValue?.name !== ''
          ? {
              streamId: departValue?.id,
              stream: departData?.filter(
                item => item?.id === departValue?.id
              )[0]?.name,
            }
          : {}),
      }
      const result = await getYear(instituteCampusId, data)

      setYearData(result)

      if (BreadYear === null) {
        // Find current year in the result, fallback to first item if not found
        const currentYear = new Date().getFullYear()
        const currentYearItem = result.find(item => item.year === currentYear) || result[0]
        setYearValue({ year: currentYearItem.year, endedOn: currentYearItem.endedOn })
        return { year: currentYearItem.year, endedOn: currentYearItem.endedOn }
      } else if (
        BreadYear &&
        BreadYear === 'null' &&
        BreadYear === 'undefined'
      ) {
        setYearValue({
          year: '',
          endedOn: '',
        })
        return { year: '', endedOn: '' }
      } else {
        const yearfilter = result.filter(
          item => item.year === parseInt(BreadYear)
        )

        if (yearfilter?.length == 0 && BreadYear !== 'undefined') {
          if (
            BreadEduType &&
            BreadDomain &&
            BreadDegreeQuery &&
            BreadDepart &&
            DomainId &&
            DegreeId &&
            BreadDepartId
          ) {
            BreadShowStudent
              ? navigate(
                  `?groupBy=students&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(BreadDepart)}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${BreadDepartId}&year=${result[0].year}&showStudent=true`
                )
              : navigate(
                  `?groupBy=students&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(BreadDepart)}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${BreadDepartId}&year=${result[0].year}`
                )
          } else if (
            BreadEduType &&
            BreadDomain &&
            BreadDegreeQuery &&
            DomainId &&
            DegreeId
          ) {
            BreadShowStudent
              ? navigate(
                  `?groupBy=stream&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${result[0].year}&showStudent=true`
                )
              : navigate(
                  `?groupBy=stream&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${result[0].year}`
                )
          } else if (BreadEduType && BreadDomain && DomainId) {
            BreadShowStudent
              ? navigate(
                  `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${result[0].year}&showStudent=true`
                )
              : navigate(
                  `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${result[0].year}`
                )
          } else {
            BreadShowStudent
              ? navigate(
                  `/placement?groupBy=domain&overview=${BreadOverview}&educationType=${BreadEduType}&year=${result[0].year}&showStudent=true`
                )
              : navigate(
                  `/placement?groupBy=domain&overview=${BreadOverview}&educationType=${BreadEduType}&year=${result[0].year}`
                )
          }
          setYearValue({
            year: result[0]?.year,
            endedOn: result[0]?.endedOn,
          })
          return { year: result[0].year, endedOn: result[0].endedOn }
        } else {
          setYearValue({
            year: yearfilter[0]?.year,
            endedOn: yearfilter[0]?.endedOn,
          })
          return { year: yearfilter[0]?.year, endedOn: yearfilter[0]?.endedOn }
        }
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }
  const fetchJobCategory = async () => {
    const response = await getJobCategory()
    setJobCategoryList(response?.data)
  }

  useEffect(() => {
    getYearData()
    fetchJobCategory()
  }, [])

  const handleDegreeChange = async (e, option) => {
    if (option === undefined) {
      setDegreeValue({ name: '', id: '' })
      setDepartValue({ name: '', id: '' })
      navigate(
        `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&domainId=${DomainId}&year=${BreadYear}&showStudent=true`
      )
    } else {
      setDegreeValue(option)
      navigate(
        `/placement?groupBy=stream&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${option.name}&domainId=${DomainId}&degreeId=${option.id}&year=${BreadYear}&showStudent=true`
      )
      const getDepart = await getPlacementData(
        instituteCampusId,
        'stream',
        BreadEduType,
        DomainId,
        option.id
      )
      setDepartData(getDepart.data.result)
      setDepartValue({ name: '', id: '' })
    }
    setPageSize(0)
    setTableDataLoaded(true)
  }

  const handleDepartChange = (e, option) => {
    if (option === undefined) {
      setDepartValue({ name: '', id: '' })
      navigate(
        `?groupBy=stream&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(BreadDomain ?? '')}&degree=${BreadDegreeQuery}&domainId=${DomainId}&degreeId=${DegreeId}&year=${BreadYear}&showStudent=true`
      )
    } else {
      setDepartValue(option)
      navigate(
        `?groupBy=students&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${BreadDomain}&degree=${BreadDegreeQuery}&department=${encodeURIComponent(option.name)}&domainId=${DomainId}&degreeId=${DegreeId}&departmentId=${option.id}&year=${BreadYear}&showStudent=true`
      )
    }
    setPageSize(0)
    setTableDataLoaded(true)
  }

  const handleYearChange = (e, option) => {
    const searchParams = new URLSearchParams(location.search)

    searchParams.set('year', option?.label)

    let newUrl = ''
    searchParams.forEach((value, key) => {
      let encodedKey = encodeURIComponent(key)
      let encodedValue = encodeURIComponent(value)
      encodedValue = encodedValue.replace(/%2C/g, ',')
      newUrl += encodedKey + '=' + encodedValue + '&'
    })

    navigate(`?${newUrl.slice(0, -1)}`)
    if (option === undefined) {
      setYearValue({ year: '', endedOn: '' })
    } else {
      setYearValue({ year: option?.label, endedOn: option?.value })
    }
    setPageSize(0)
    setTableDataLoaded(true)
  }

  const handleDomainChange = async (e, option) => {
    if (option === undefined) {
      setDomainValue({ name: '', id: '' })
      setDegreeValue({ name: '', id: '' })
      setDepartValue({ name: '', id: '' })
      navigate(
        `/placement?groupBy=domain&overview=${BreadOverview}&educationType=${BreadEduType}&year=${BreadYear}&showStudent=true`
      )
    } else {
      setDomainValue(option)
      navigate(
        `/placement?groupBy=degree&overview=${BreadOverview}&educationType=${BreadEduType}&domain=${encodeURIComponent(option.name)}&domainId=${option.id}&year=${BreadYear}&showStudent=true`
      )
      const getDegree = await getPlacementData(
        instituteCampusId,
        'degree',
        BreadEduType,
        option.id
      )
      setDegreeData(getDegree.data.result)
      setDegreeValue({ name: '', id: '' })
      setDepartValue({ name: '', id: '' })
    }

    setPageSize(0)
    setTableDataLoaded(true)
  }

  const handleFolderData = async search => {
    try {
      const rolesList = await getPlacementData(
        instituteCampusId,
        GroupBy,
        BreadEduType,
        DomainId,
        DegreeId,
        search === true ? debouncedFolderSearch : ''
      )
      if (rolesList?.data?.nextGroupBy === 'domain') {
        const order = ['UG', 'PG', 'PHD', 'DIPLOMA', 'P.G.DIPLOMA', 'DOCTORATE']

        rolesList?.data?.result?.sort((a, b) => {
          return order.indexOf(a.type) - order.indexOf(b.type)
        })
        rolesList.data.result = rolesList.data.result.map(item => {
          if (item.type == 'DIPLOMA') {
            return { type: 'Diploma' }
          } else if (item.type === 'P.G.DIPLOMA') {
            return { type: 'P.g.Diploma' }
          }
          return item
        })
        setFolderData(rolesList?.data)
      } else {
        setFolderData(rolesList?.data)
      }
      let pay = {
        forCount: true,
        ...(GroupBy !== 'type' ? { educationLevel: BreadEduType } : {}),
        ...(DomainId ? { domainId: DomainId } : {}),
        ...(BreadYear && BreadYear !== 'null' && BreadYear !== 'undefined'
          ? {
              yearOfPassing: yearValue?.endedOn,
            }
          : {}),
        ...(DegreeId
          ? {
              degreeId: DegreeId,
              degree: BreadDegree?.replace(/%20/g, ' '),
            }
          : {}),
        ...(search === true ? { search: debouncedFolderSearch.trim() } : {}),
      }
      const data = await getYearData(pay)
      let payLoad = {
        ...pay,
        ...(data && data?.year !== ''
          ? {
              yearOfPassing: data?.endedOn,
            }
          : {}),
      }
      const getplacementStudent = await getPlacementStudent(
        instituteCampusId,
        payLoad
      )

      setPlacementStudent(getplacementStudent)
    } catch (error) {
      ErrorMessage(error)
    }
  }

  useEffect(() => {
    if (BreadShowStudent !== 'true') {
      setFolderData([])
      setFolderSearch('')
      setSearchData(false)
      handleFolderData()
    }
  }, [getLocation.search])

  useEffect(() => {
    if (BreadShowStudent !== 'true' && searchData) {
      setFolderData([])
      handleFolderData(true)
    }
  }, [debouncedFolderSearch])

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedFolderSearch(folderSearch)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [folderSearch])

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchBy)
      setPageSize(0)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchBy])

  useEffect(() => {
    if (BreadShowStudent) {
      setDomainValue({ name: '', id: '' })
      setDegreeValue({ name: '', id: '' })
      setDepartValue({ name: '', id: '' })
      const handleFilterData = async () => {
        try {
          setTableLoader(true)
          const domain = await getPlacementData(
            instituteCampusId,
            'domain',
            BreadEduType
          )
          setDomainData(domain.data.result)
          setDomainValue({
            name: BreadDomain?.replace(/%20/g, ' ') || '',
            id: DomainId?.replace(/%20/g, ' '),
          })
          if (DomainId) {
            const getDegree = await getPlacementData(
              instituteCampusId,
              'degree',
              BreadEduType,
              DomainId
            )
            setDegreeData(getDegree.data.result)
            setDegreeValue({
              name: BreadDegree?.replace(/%20/g, ' ') || '',
              id: DegreeId?.replace(/%20/g, ' ') || '',
            })
          }
          if (DegreeId) {
            const getDepart = await getPlacementData(
              instituteCampusId,
              'stream',
              BreadEduType,
              DomainId,
              DegreeId
            )
            setDepartData(getDepart.data.result)
            setDepartValue({
              name: BreadDepart?.replace(/%20/g, ' ') || '',
              id: BreadDepartId?.replace(/%20/g, ' '),
            })
          }
          if (
            BreadYear &&
            BreadYear !== 'null' &&
            BreadYear !== 'undefined' &&
            yearData.length !== 0
          ) {
            const yearfilter = yearData.filter(
              item => item.year === parseInt(BreadYear)
            )
            setYearValue({
              year: yearfilter[0]?.year,
              endedOn: yearfilter[0]?.endedOn,
            })
          }

          setTableDataLoaded(true)
        } catch (error) {
          setTableLoader(false)
          ErrorMessage(error)
        }
      }

      handleFilterData()
    }
  }, [BreadShowStudent])

  useEffect(() => {
    if (BreadDomain) {
      setDomainValue({
        name: BreadDomain?.replace(/%20/g, ' ') || '',
        id: DomainId?.replace(/%20/g, ' '),
      })
    }
  }, [BreadDomain])

  useEffect(() => {
    if (tableDataLoaded && BreadShowStudent) {
      setSearchBy('')
      setSearchFilter(false)
      handleTableData()
    }
  }, [BreadShowStudent, tableDataLoaded, pageSize, filterDatas])

  useEffect(() => {
    if (searchFilter) {
      handleTableData(true)
    }
  }, [debouncedSearch, sortBy])

  const handleTableData = async search => {
    if(bulkDownload !== true ){
      setTableLoader(true)
    }

    try {
      let pay = {
        pageLimit: 10,
        pageNo: pageSize,
        educationLevel: BreadEduType,
        ...(yearValue && yearValue?.year !== ''
          ? {
              yearOfPassing: yearValue?.endedOn,
            }
          : {}),
        ...(domainValue && domainValue?.name !== ''
          ? {
              domainId: domainValue?.id,
            }
          : {}),
        ...(degreeValue && degreeValue?.name !== ''
          ? {
              degreeId: degreeValue?.id,
              degree: degreeData?.filter(
                item => item?.id === degreeValue?.id
              )[0]?.name,
            }
          : {}),
        ...(departValue && departValue?.name !== ''
          ? {
              streamId: departValue?.id,
              stream: departData?.filter(
                item => item?.id === departValue?.id
              )[0]?.name,
            }
          : {}),

        ...(debouncedSearch !== '' && search === true
          ? {
              searchBy: debouncedSearch.trim(),
            }
          : {}),
        ...(sortBy !== ''
          ? {
              sortBy: sortBy?.columnKey ? sortBy?.columnKey : '',

              orderBy: sortBy?.order
                ? sortBy?.order === 'ascend'
                  ? 'asc'
                  : 'desc'
                : 'asc',
            }
          : {}),
        ...(filterDatas.length !== 0 ? { employmentFilter: filterDatas } : {}),
      }
      const data = await getYearData(pay)
      let payload = {
        ...pay,
        ...(data && data?.year !== ''
          ? {
              yearOfPassing: data?.endedOn,
            }
          : {}),
      }
      if(bulkDownload){
        payload.bulkDownload = true
      }
      const getdata = await getTableData(instituteCampusId, payload)
      if(bulkDownload === true){
        setActionDrawer(true)
        setStudentId(getdata.data.studentIds)
        setBulkDownload(false)
      }else{
        setStudentCount(getdata?.data?.count)
        setStudentId(getdata?.data?.result)
        setTableData(getdata)
        setTableLoader(false)
        setPlacementStudent(getdata)
        setTableDataLoaded(false)
        if (recentFolderClick) {
          await handleUserBatchHistory('PUT', window.location.search)
          setRecentFolderClick(false)
        }
      }
    } catch (error) {
      ErrorMessage(error)
      setTableLoader(false)
    }
  };

  useEffect (()=>{

    if(bulkDownload){
      handleTableData()
    }
  },[bulkDownload])

  const handlePageChange = pageNum => {
    setPageSize(pageNum - 1)
    setTableDataLoaded(true)
  }

  const handleSorting = (pagination, filter, sorter) => {
    if (!sorter.order) {
      setSortBy('')
    } else {
      setSortBy(sorter)
    }
    setSearchFilter(true)
  }
  const handleUserBatchHistory = async (method, route, dept) => {
    const currentDateTime = new Date(Date.now())
    let payload = {
      batchHistory: {
        ...(BreadYear === 'undefined'
          ? {}
          : yearValue?.year !== ''
          ? { yearOfPassing: yearValue?.year, endedOn: yearValue?.endedOn }
          : {}),
        viewedAt: currentDateTime,
        educationType: BreadEduType || '',
        domain: BreadDomain || '',
        degree: BreadDegree?.replace(/%20/g, ' '),
        dept: BreadDepart?.replace(/%20/g, ' ') ?? dept ?? '',
        degreeShortForm: BreadDegreeShortForm || '',
        route: route?.replace(/%20/g, ' ') || '',
      },
    }
    if (method == 'GET') {
      const data = await getUserBatchHistory(instituteCampusId)
      if (data?.batchHistory?.length) {
        setBatchHistory(data?.batchHistory || [])
      }
    }
    if (method == 'PUT') {
      const data = await updateUserBatchHistory(instituteCampusId, payload)
      if (data?.batchHistory?.length) {
        setBatchHistory(data?.batchHistory?.reverse() || [])
      }
    }
  }
  useLayoutEffect(() => {
    handleUserBatchHistory('GET')
  }, [])

  const handleShowFolder = () => {
    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    params.delete('showStudent')
    if (params.has('department') || params.has('departmentId')) {
      params.delete('department')
      params.delete('departmentId')
      params.set('groupBy', 'stream')
    }

    let newUrl = ''
    params.forEach((value, key) => {
      const decodedKey = decodeURIComponent(key)
      const decodedValue = decodeURIComponent(value.replace(/\+/g, ' '))
      newUrl += `${decodedKey}=${decodedValue}&`
    })
    newUrl = newUrl.slice(0, -1)

    return navigate(`/placement?${newUrl}`)
  }

  const [internshipsData, setInternshipsData] = useState([
    {
      label: 'Applied',
      value: 'applied',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'From',
      status: 'INTERNSHIP',
    },
    {
      label: 'Eligible',
      value: 'eligible',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'To',
      status: 'INTERNSHIP',
    },
  ])

  const [gigsData, setGigsData] = useState([
    {
      label: 'Applied',
      value: 'applied',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'From',
      status: 'GIGS',
    },
    {
      label: 'Eligible',
      value: 'eligible',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'To',
      status: 'GIGS',
    },
  ])

  const [apprenticeshipData, setApprenticeshipData] = useState([
    {
      label: 'Applied',
      value: 'applied',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'From',
      status: 'APPRENTICESHIP',
    },
    {
      label: 'Eligible',
      value: 'eligible',
      hasInput: true,
      fromValue: '',
      toValue: '',
      placeholder: 'To',
      status: 'APPRENTICESHIP',
    },
  ])

  const [placementData, setPlacementData] = useState([
    {
      label: 'Applied',
      value: 'applied',
      placeholder: 'From',
      fromValue: '',
      toValue: '',
      status: 'PLACEMENT',
    },
    {
      label: 'Eligible',
      value: 'eligible',
      placeholder: 'To',
      fromValue: '',
      toValue: '',
      status: 'PLACEMENT',
    },
    {
      label: 'Placed',
      value: 'isPlaced',
      status: 'PLACEMENT',
      fromValue: '',
      toValue: '',
    },
    {
      label: 'UnPlaced',
      value: 'unPlaced',
      status: 'PLACEMENT',
      fromValue: '',
      toValue: '',
    },
  ])

  const handlePlacementChange = value => {
    setPlacementData(prevData =>
      prevData.map(internship =>
        internship.value === value
          ? {
              ...internship,
              fromValue: selectPlacement === value ? '' : internship.fromValue,
              toValue: selectPlacement === value ? '' : internship.toValue,
            }
          : { ...internship, fromValue: '', toValue: '' }
      )
    )
    setSelectPlacement(previous => (previous === value ? null : value))
  }
  const handleInternshipChange = value => {
    setInternshipsData(prevData =>
      prevData.map(internship =>
        internship.value === value
          ? {
              ...internship,
              fromValue: selectInternship === value ? '' : internship.fromValue,
              toValue: selectInternship === value ? '' : internship.toValue,
            }
          : { ...internship, fromValue: '', toValue: '' }
      )
    )
    setSelectInternship(previous => (previous === value ? null : value))
  }

  const handleGigasChange = value => {
    setGigsData(prevData =>
      prevData.map(internship =>
        internship.value === value
          ? {
              ...internship,
              fromValue: selectGigas === value ? '' : internship.fromValue,
              toValue: selectGigas === value ? '' : internship.toValue,
            }
          : { ...internship, fromValue: '', toValue: '' }
      )
    )
    setSelectGigas(previous => (previous === value ? null : value))
  }

  const handleApprenticeshipChange = value => {
    setApprenticeshipData(prevData =>
      prevData.map(internship =>
        internship.value === value
          ? {
              ...internship,
              fromValue:
                selectApprenticeship === value ? '' : internship.fromValue,
              toValue: selectApprenticeship === value ? '' : internship.toValue,
            }
          : { ...internship, fromValue: '', toValue: '' }
      )
    )
    setSelectApprenticeship(previous => (previous === value ? null : value))
  }

  const handleInputChange = (check, value, inputVal, status) => {
    if (check === 'From' && status === 'INTERNSHIP') {
      setInternshipsData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, fromValue: inputVal }
            : { ...internship, fromValue: '' }
        )
      )
    } else if (check === 'To' && status === 'INTERNSHIP') {
      setInternshipsData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, toValue: inputVal }
            : { ...internship, toValue: '' }
        )
      )
    } else if (check === 'From' && status === 'PLACEMENT') {
      setPlacementData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, fromValue: inputVal }
            : { ...internship, fromValue: '' }
        )
      )
    } else if (check === 'To' && status === 'PLACEMENT') {
      setPlacementData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, toValue: inputVal }
            : { ...internship, toValue: '' }
        )
      )
    } else if (check === 'From' && status === 'GIGS') {
      setGigsData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, fromValue: inputVal }
            : { ...internship, fromValue: '' }
        )
      )
    } else if (check === 'To' && status === 'GIGS') {
      setGigsData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, toValue: inputVal }
            : { ...internship, toValue: '' }
        )
      )
    } else if (check === 'From' && status === 'APPRENTICESHIP') {
      setApprenticeshipData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, fromValue: inputVal }
            : { ...internship, fromValue: '' }
        )
      )
    } else if (check === 'To' && status === 'APPRENTICESHIP') {
      setApprenticeshipData(prevData =>
        prevData.map(internship =>
          internship.value === value
            ? { ...internship, toValue: inputVal }
            : { ...internship, toValue: '' }
        )
      )
    }
  }

  const hanldeApplyFilter = () => {
    const filterinternship = internshipsData.filter(
      item => item.value === selectInternship
    )
    const filterplacement = placementData.filter(
      item => item.value === selectPlacement
    )

    const filterGigas = gigsData.filter(item => item.value === selectGigas)
    const filterApprenticeship = apprenticeshipData.filter(
      item => item.value === selectApprenticeship
    )

    const setdataInternship = filterinternship.map(item => {
      return {
        employmentType: item.status,
        case: item.value,
        from: item.fromValue === '' ? 0 : parseInt(item.fromValue),
        ...(item.toValue === ''
          ? {}
          : { to: item.toValue === '' ? 0 : parseInt(item.toValue) }),

        nameValue: `${item.status} ${item.label} ${
          item.fromValue !== '' ? item.fromValue : ''
        } ${item.toValue !== '' ? ' - ' + item.toValue : ''}`,
      }
    })

    const setdataPlacement = filterplacement.map(item => {
      return {
        employmentType: item.status,
        case: item.value,
        from:
          item.value === 'placed' || item.value === 'unPlaced'
            ? 0
            : item.fromValue === ''
            ? 0
            : parseInt(item.fromValue),
        ...(item.value === 'placed' || item.toValue === ''
          ? {}
          : {
              to:
                item.value === 'unPlaced'
                  ? 0
                  : item.toValue === ''
                  ? 0
                  : parseInt(item.toValue),
            }),
        nameValue: `${item.status} ${item.label} ${
          item.fromValue !== '' ? item.fromValue : ''
        } ${item.toValue !== '' ? ' - ' + item.toValue : ''}`,
      }
    })

    const setdataGigas = filterGigas.map(item => {
      return {
        employmentType: item.status,
        case: item.value,
        from: item.fromValue === '' ? 0 : parseInt(item.fromValue),
        ...(item.toValue === ''
          ? {}
          : { to: item.toValue === '' ? 0 : parseInt(item.toValue) }),
        nameValue: `${item.status} ${item.label} ${
          item.fromValue !== '' ? item.fromValue : ''
        } ${item.toValue !== '' ? ' - ' + item.toValue : ''}`,
      }
    })

    const setdataApprenticeship = filterApprenticeship.map(item => {
      return {
        employmentType: item.status,
        case: item.value,
        from: item.fromValue === '' ? 0 : parseInt(item.fromValue),
        ...(item.toValue === ''
          ? {}
          : { to: item.toValue === '' ? 0 : parseInt(item.toValue) }),
        nameValue: `${item.status} ${item.label} ${
          item.fromValue !== '' ? item.fromValue : ''
        } ${item.toValue !== '' ? ' - ' + item.toValue : ''}`,
      }
    })

    if (
      setdataInternship.length !== 0 &&
      setdataInternship[0].from > setdataInternship[0].to
    ) {
      ErrorMessage(
        `${setdataInternship[0].employmentType} From value ${setdataInternship[0].from} is more than To value ${setdataInternship[0].to}`
      )
    } else if (
      setdataPlacement.length !== 0 &&
      setdataPlacement[0].from > setdataPlacement[0].to
    ) {
      ErrorMessage(
        `${setdataPlacement[0].employmentType} From value ${setdataPlacement[0].from} is more than To value ${setdataPlacement[0].to}`
      )
    } else if (
      setdataGigas.length !== 0 &&
      setdataGigas[0].from > setdataGigas[0].to
    ) {
      ErrorMessage(
        `${setdataGigas[0].employmentType} From value ${setdataGigas[0].from} is more than To value ${setdataGigas[0].to}`
      )
    } else if (
      setdataApprenticeship.length !== 0 &&
      setdataApprenticeship[0].from > setdataApprenticeship[0].to
    ) {
      ErrorMessage(
        `${setdataApprenticeship[0].employmentType} From value ${setdataApprenticeship[0].from} is more than To value ${setdataApprenticeship[0].to}`
      )
    } else {
      setPageSize(0)
      setTableDataLoaded(true)
      setFilterDatas([
        ...setdataInternship,
        ...setdataPlacement,
        ...setdataGigas,
        ...setdataApprenticeship,
      ])
      setIsMenuOpen(false)
    }
  }
  const handleApprove = async () =>{
    setIsAllSelect(false);
    setEnabled(false);
    setActionDrawer(false);
    let payload ={
      email: userData.email,
      instName: instituteDetails.campusName,
      state: instituteDetails.state,
      city:instituteDetails.city,
      user:userData.first_name +' '+ userData.last_name,
      studentIds:isAllSelect === true ? StudentId:[studentListId]
    }
    
    setActionDrawer(false);
    setBulkDownload(false);
    setIsAllSelect(false);
    if(payload.studentIds[0].length > 5){
        setShowSuccessPopup(true);
  }
  setStudentListId([])
      const response = await resumeBulkDownload(payload);
    
      if (response?.data) {
        if (payload.studentIds[0].length === 1) {
          const studentData = placementStudent?.data?.result.filter(p=>p.id === payload.studentIds[0][0]);
          const studentName = studentData[0]?.firstname +' '+ studentData[0]?.lastname;
          await singlePdf(response,studentName,studentData[0]?.id);
        } else if (payload.studentIds[0].length <= 5) {
          await zipFile(response.data);
        }
      
    };
  }


  const handleClose =() =>{
    setActionDrawer(false)
  }

  const FilterMenu = (
    <MenuFlex column>
      <StyledTab
        width={'35%'}
        padding={'20px'}
        border={true}
        tabPosition={'left'}
        type="card"
        items={[
          {
            label: ' Internships',
            key: '1',
            children: (
              <InternshipsFilter
                InternshipsData={internshipsData}
                handleInternshipChange={handleInternshipChange}
                selectInternship={selectInternship}
                handleInputChange={handleInputChange}
              />
            ),
          },
          {
            label: 'Placement',
            key: '2',
            children: (
              <PlacementFilter
                PlacementData={placementData}
                selectPlacement={selectPlacement}
                handleInputChange={handleInputChange}
                handlePlacementChange={handlePlacementChange}
              />
            ),
          },
          {
            label: 'Gigs',
            key: '3',
            children: (
              <InternshipsFilter
                InternshipsData={gigsData}
                handleInternshipChange={handleGigasChange}
                selectInternship={selectGigas}
                handleInputChange={handleInputChange}
              />
            ),
          },
          {
            label: 'Apprenticeship',
            key: '4',
            children: (
              <InternshipsFilter
                InternshipsData={apprenticeshipData}
                handleInternshipChange={handleApprenticeshipChange}
                selectInternship={selectApprenticeship}
                handleInputChange={handleInputChange}
              />
            ),
          },
        ].filter(item => !item.hidden)}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => setIsMenuOpen(false)} />
        <Button.Primary text="Apply Filter" onClick={hanldeApplyFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  const handleMultiFilter = value => {
    const getdata = filterDatas.filter(item => !value.includes(item.nameValue))

    const multi = getdata[0].employmentType

    const data = filterDatas.filter(
      item =>
        !getdata.some(
          getvalue => getvalue.employmentType === item.employmentType
        )
    )

    if (multi === 'INTERNSHIP') {
      setSelectInternship(null)
      setInternshipsData(
        internshipsData.map(item => {
          return { ...item, fromValue: '', toValue: '' }
        })
      )
    } else if (multi === 'PLACEMENT') {
      setSelectPlacement(null)
      setPlacementData(
        placementData.map(item => {
          return { ...item, fromValue: '', toValue: '' }
        })
      )
    } else if (multi === 'GIGS') {
      setSelectGigas(null)
      setGigsData(
        gigsData.map(item => {
          return { ...item, fromValue: '', toValue: '' }
        })
      )
    } else if (multi === 'APPRENTICESHIP') {
      setSelectApprenticeship(null)
      setApprenticeshipData(
        apprenticeshipData.map(item => {
          return { ...item, fromValue: '', toValue: '' }
        })
      )
    } else {
      return {}
    }
    setFilterDatas(data)
    setTableDataLoaded(true)
  }

  const handleFolderSearch = e => {
    setFolderSearch(e.target.value)
    setSearchData(true)
  }

  const handleSearch = e => {
    setSearchBy(e.target.value)
    setSearchFilter(true)
  }

  const handleNavigateBack = () => {
    setPageSize(0)
    setFilterDatas([])
    setSelectPlacement(null)
    console.log(breadCrumbData,'breadCrumbData')
    const data = breadCrumbData.filter(
      item => (item.title !== 'undefined' && item.title !== 'null') && item.active !== true
    )
    navigate(data[data.length - 1].navigate)
    setEnabled(false);
    setIsAllSelect(false)
    setStudentId([])
    setStudentListId([])
  }
  const handleSelectAll = () => {
    setIsAllSelect(true)
    setStudentId([])
  }

  const closePopup = () => {
    setShowSuccessPopup(false)
  }

  const handleClearAll = () => {
    setEnabled(false);
    setIsAllSelect(false)
    setStudentId([])
    setStudentListId([])
  }

  return (
    <PlacementFlex>
      <Header
        breadCrumbData={breadCrumbData}
        handleShowStudent={handleShowStudent}
        BreadShowStudent={BreadShowStudent}
        currentSearchParams={currentSearchParams}
        placementStudent={placementStudent}
        handleShowFolder={handleShowFolder}
        handleNavigateBack={handleNavigateBack}
        tableloader={tableLoader}
        setIsNavigateEnabled={setIsNavigateEnabled}
        setBulkDownload={setBulkDownload}
        studentListId={studentListId}
        isAllSelect={isAllSelect}
        setActionDrawer={setActionDrawer}
        setStudentListId={setStudentListId}
        setIsAllSelect={setIsAllSelect}
        setStudentId={setStudentId}
      />
  
      {currentSearchParams.size !== 0 && (
        <FilterGap>
          <FilterData
            degreeData={degreeData}
            handleDegreeChange={handleDegreeChange}
            degreeValue={degreeValue.name}
            departValue={departValue.name}
            handleDepartChange={handleDepartChange}
            domainData={domainData}
            domainValue={domainValue.name}
            handleDomainChange={handleDomainChange}
            GroupBy={GroupBy}
            BreadShowStudent={BreadShowStudent}
            departData={departData}
            yearData={yearData}
            yearValue={yearValue.year}
            handleYearChange={handleYearChange}
          />
          
          <TableData
            placeholder={
              'Search by ' +
              (BreadShowStudent === 'true'
                ? 'name'
                : GroupBy == 'students' || GroupBy == 'stream'
                ? 'department'
                : GroupBy)
            }
            BreadShowStudent={BreadShowStudent}
            folderSearch={folderSearch}
            setFolderSearch={setFolderSearch}
            tableData={tableData}
            handlePageChange={handlePageChange}
            pageSize={pageSize}
            tableloader={tableLoader}
            searchBy={searchBy}
            handleSorting={handleSorting}
            FilterMenu={FilterMenu}
            isMenuOpen={isMenuOpen}
            setIsMenuOpen={setIsMenuOpen}
            onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
            filterdata={filterDatas}
            handleMultiFilter={handleMultiFilter}
            handleSearch={handleSearch}
            handleFolderSearch={handleFolderSearch}
            getPreviewData={getPreviewData}
            getJobRolePreview={getJobRolePreview}
            getStudentPlacedList={getStudentPlacedList}
            getPlacementHistoryList={getPlacementHistoryList}
            jobCategoryList={jobCategoryList}
            selectedStudents={studentListId}
            setSelectedStudents={setStudentListId}
            isAllSelect={isAllSelect}
            setIsAllSelect = {setIsAllSelect}
            enabled={enabled}
            setEnabled={setEnabled}
            studentCount={studentCount}
            handleClearAll={handleClearAll}
          handleSelectAll={handleSelectAll}
          studentListId={studentListId}
          />
        </FilterGap>
      )}
      {BreadShowStudent !== 'true' && (
        <FolderPath
          handleRouteCheck={handleRouteCheck}
          folderData={folderData}
          currentSearchParams={currentSearchParams}
          batchHistory={batchHistory}
          GroupBy={GroupBy}
          handleRecentRoute={handleRecentRoute}
        />
      )}
      <CloseRoleDrawer 
        description="Are you sure you want to download all selected resumes?"
        Icon={PopUpPageIcon}
        showDrawer={actionDrawer}
        setShowDrawer={setActionDrawer}
        onCloseClick={handleClose}
        onApprove={handleApprove}
        closeText="No"
       YesText="Yes"
      closeButtonHeight="38px"
      closeButtonWidth="80px"
      yesButtonHeight="38px"
      yesButtonWidth="105px"
      />
        <SucessfullPopup
                description={
                   <div>Your request is being processed. Please check your email inbox shortly for the download link.</div>
                }
                Icon={SuccessIcon}
                showDrawer={showSuccessPopup}
                setShowDrawer={setShowSuccessPopup}
                onCloseClick={closePopup}
              />
    </PlacementFlex>
  )
}

export default Placement
